import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useContext } from 'react';
import { Icon } from '../index';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import { tuple } from '../_utils/type';
import devWarning from '../_utils/devwarning';
export var ButtonTypes = tuple('second', 'primary', 'ghost', 'text');
export var ButtonSizes = tuple('large', 'middle', 'small');
export var ButtonShapes = tuple('circle', 'round', 'none');
export var ButtonIconPlaces = tuple('left', 'right');
export var ButtonHTMLTypes = tuple('submit', 'button', 'reset');

var InternalButton = function InternalButton(props, ref) {
  var _context, _context2, _context3, _classNames, _context4, _context5;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      userDefaultProps = _useContext.compDefaultProps;

  var buttonProps = getCompProps('Button', userDefaultProps, props); // 按钮属性需要合并一遍用户定义的默认属性

  var type = buttonProps.type,
      iconPlace = buttonProps.iconPlace,
      children = buttonProps.children,
      className = buttonProps.className,
      customPrefixcls = buttonProps.prefixCls,
      size = buttonProps.size,
      loading = buttonProps.loading,
      shape = buttonProps.shape,
      bordered = buttonProps.bordered,
      onClick = buttonProps.onClick,
      icon = buttonProps.icon,
      ghost = buttonProps.ghost,
      block = buttonProps.block,
      disabled = buttonProps.disabled,
      _buttonProps$htmlType = buttonProps.htmlType,
      htmlType = _buttonProps$htmlType === void 0 ? 'button' : _buttonProps$htmlType,
      others = __rest(buttonProps, ["type", "iconPlace", "children", "className", "prefixCls", "size", "loading", "shape", "bordered", "onClick", "icon", "ghost", "block", "disabled", "htmlType"]);

  devWarning(ButtonTypes.indexOf(type) === -1, 'button', "cannot found button type '".concat(type, "'"));
  var btnPrefixCls = getPrefixCls(prefixCls, 'btn', customPrefixcls); // 按钮样式前缀

  /**
   * 按钮click事件处理
   * @param {React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>} e 事件对象
   */

  var handleClick = function handleClick(e) {
    if (loading) {
      // 加载中不触发点击事件
      return;
    }

    var waveStatus = buttonRef.current.getAttribute('click-animating-wave'); // 进入时是否在加载动画

    if (waveStatus === 'true') {
      buttonRef.current.setAttribute('click-animating-wave', false); // eslint-disable-next-line @typescript-eslint/no-unused-expressions

      window.getComputedStyle(buttonRef.current).animationPlayState;
    } // 启动动画


    buttonRef.current.setAttribute('click-animating-wave', true);
    buttonRef.current.addEventListener('animationend', onAnimationEnd);
    onClick && onClick(e);
  };

  var onAnimationEnd = function onAnimationEnd(e) {
    if (e.animationName === 'waveEffect') {
      return;
    }

    e.target.setAttribute('click-animating-wave', 'false');
    removeEventListener('animationend', onAnimationEnd);
  }; // ref


  var buttonRef = ref || /*#__PURE__*/React.createRef(); // 对children进行进一步处理，目前只处理typeof child === 'string'的情况，后续有特殊情况的在此方法处理

  var handleChild = function handleChild(child) {
    if (typeof child === 'string') {
      return /*#__PURE__*/React.createElement("span", null, child); // 包一层span,该层span的dsiplay为inline-block, 用于处理没内容时按钮高度位置跳动问题
    }

    return child;
  };

  var isTextBtn = type === 'text'; // 判断按钮是否文本类型。这些类型下有部分样式不适用

  var btnClasses = classNames(btnPrefixCls, className, (_classNames = {}, _defineProperty(_classNames, _concatInstanceProperty(_context = "".concat(btnPrefixCls, "-")).call(_context, type), type), _defineProperty(_classNames, _concatInstanceProperty(_context2 = "".concat(btnPrefixCls, "-size-")).call(_context2, size), size), _defineProperty(_classNames, _concatInstanceProperty(_context3 = "".concat(btnPrefixCls, "-shape-")).call(_context3, shape), shape && !isTextBtn), _defineProperty(_classNames, "".concat(btnPrefixCls, "-no-border"), !bordered), _defineProperty(_classNames, "".concat(btnPrefixCls, "-background-ghost"), ghost && !disabled), _defineProperty(_classNames, "".concat(btnPrefixCls, "-loading"), loading && !isTextBtn), _defineProperty(_classNames, "".concat(btnPrefixCls, "-block"), block && !shape), _defineProperty(_classNames, "".concat(btnPrefixCls, "-icon-only"), !children && children !== 0 && icon), _classNames));

  var iconWrapperClassName = _concatInstanceProperty(_context4 = "".concat(btnPrefixCls, "-iconWrapper-")).call(_context4, iconPlace === 'left' ? 'left' : 'right');

  var iconNode = icon && !loading ? /*#__PURE__*/React.createElement("span", {
    className: iconWrapperClassName
  }, icon) : loading ? /*#__PURE__*/React.createElement("span", {
    className: iconWrapperClassName
  }, /*#__PURE__*/React.createElement(Icon, {
    className: _concatInstanceProperty(_context5 = "".concat(btnPrefixCls, "-")).call(_context5, type === ButtonTypes[1] ? 'primary-loadingIcon' : 'loadingIcon'),
    type: "loadding",
    spin: true
  })) : null;
  var btnChild = handleChild(children);

  switch (type) {
    case 'text':
      return /*#__PURE__*/React.createElement("span", _extends({
        ref: buttonRef,
        className: btnClasses,
        onClick: handleClick,
        disabled: disabled
      }, others), children);

    default:
      return /*#__PURE__*/React.createElement("button", _extends({
        ref: buttonRef,
        className: btnClasses,
        onClick: handleClick,
        disabled: disabled,
        type: htmlType
      }, others, {
        "click-animating-wave": "false"
      }), iconPlace === 'left' ? /*#__PURE__*/React.createElement(React.Fragment, null, iconNode, !!(iconNode && children) && /*#__PURE__*/React.createElement("span", {
        className: "btn-space"
      }), btnChild) : /*#__PURE__*/React.createElement(React.Fragment, null, btnChild, !!(iconNode && children) && /*#__PURE__*/React.createElement("span", {
        className: "btn-space"
      }), iconNode));
  }
};

var Button = /*#__PURE__*/React.forwardRef(InternalButton);
Button.displayName = 'Button';
export default Button;